(function () {
  'use strict';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(scope) {
    scope.querySelectorAll('video[data-sayef-autoplay]').forEach(function (video) {
      if (video.dataset.sayefVideoReady) return;
      video.dataset.sayefVideoReady = 'true';
      video.preload = 'none';
      video.muted = true;
      video.playsInline = true;
      if (reducedMotion || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.15) {
            video.pause();
            return;
          }
          if (document.hidden || video.closest('details:not([open])')) return;
          var playResult = video.play();
          if (playResult && typeof playResult.catch === 'function') {
            playResult.catch(function () {});
          }
        });
      }, { threshold: [0, 0.15] });
      observer.observe(video);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) video.pause();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(document); });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', function (event) { setup(event.target); });
})();
